/**
 *图集稿轮播图指令
 */
"use strict";
angular.module("atlasCarouselModule", []).
directive("atlasCarousel", ["$timeout", function($timeout) {
    return {
        restrict: "AE",
        scope: false,
        templateUrl: "./utils/atlasCarousel/atlasCarousel_tpl.html",
        link: function(scope, $element, $attrs) {
            $element.find(".left").click(function(){
            	if(!$element.find(".middle").is(":animated")){
            		var left = $element.find(".middle").scrollLeft();
            		$element.find(".middle").animate({scrollLeft: left-120+'px'}, 200,'swing');
            	}
            	scope.$apply(function(){
            		if(scope.selIndex>0){
            			scope.selectedPicInfo = scope.pictures[scope.selIndex-1];
            			scope.selIndex--;
            		}
            	})
            })
            $element.find(".right").click(function(){
            	if(!$element.find(".middle").is(":animated")){
	            	var left = $element.find(".middle").scrollLeft();
	            	$element.find(".middle").animate({scrollLeft: left+120+'px'}, 200,'swing');
            	}
            	scope.$apply(function(){
            		if(scope.selIndex<scope.pictures.length-1){
            			scope.selectedPicInfo = scope.pictures[scope.selIndex+1];
            			scope.selIndex++;
            		}
            	})
            })
            scope.selectPic = function(item,index){
            	scope.selectedPicInfo = item;
            	scope.selIndex = index;
            }
        }
    };
}]);